import objectFitImages from 'object-fit-images';

import {
  percentLoadingFunc
} from "./common/_common";
import {
  cameraFunc
} from "./pages/_index";
//* ---------------------------------------
//通常実行
//-------------------------------------- */
let setTimer = false;
//* ----------------------------------------
//window実行
//--------------------------------------- */
////// ロード時
$(window).on('load', function () {
  cameraFunc();
});

// リサイズ時
/*リサイズ後,200msで発火する設定*/
$(window).on('resize', function () {
  if (setTimer !== false) {
    clearTimeout(setTimer);
  }
  setTimer = setTimeout(() => {
    //処理
  }, 200);
});

// スクロール時
$(window).on('scroll', function () {
  if (setTimer !== false) {
    clearTimeout(setTimer);
  }
  setTimer = setTimeout(() => {
    //処理
  }, 200);
});
///* -----------------------------------------------
//ユーザーエージェント判別実行(uaFlag：1→スマホ&タブレット・2→IE・3→その他PC)
//----------------------------------------------- */
var uaFlag = 0;
if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
  // スマホ時の処理
  uaFlag = 1;
} else {
  // PC時の処理
  uaFlag = 3;
}

if(uaFlag == 3){
  //alert('スマホで閲覧してください。');
  $('main').addClass('hidden');
  $('.pcAlertModal').addClass('isShow');
}


const mediaQuery = window.matchMedia("(orientation: landscape)");
let landscapeFlag;

if(uaFlag == 1){
  if (mediaQuery.matches) {
    $('.spLandscapeModal').addClass('isShow');
    landscapeFlag = 1;
  } else{
    $('.spLandscapeModal').removeClass('isShow');
  }
  
  function handleOrientationChange(e) {
    if (e.matches) {
      $('.spLandscapeModal').addClass('isShow');
    } else{
      $('.spLandscapeModal').removeClass('isShow');
  
      if(landscapeFlag){
        location.reload();
      }
    }
  }
  mediaQuery.addEventListener("change", handleOrientationChange);
}

/* -----------------------------------------------
IEだけの時
----------------------------------------------- */
var userAgent = window.navigator.userAgent.toLowerCase();
if (userAgent.match(/(msie|MSIE)/) || userAgent.match(/(T|t)rident/)) {

}